module.exports = __webpack_public_path__ + "static/GT-Haptik-Regular-4a017edfd6279e17db9be28030a047ee.woff";